var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmbed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06485 5.77197C8.42283 6.1346 8.42283 6.72254 8.06485 7.08517L3.21303 12L8.06485 16.9148C8.42283 17.2775 8.42283 17.8654 8.06485 18.228C7.70687 18.5907 7.12647 18.5907 6.76849 18.228L1.26849 12.6566C0.910505 12.294 0.910505 11.706 1.26849 11.3434L6.76849 5.77197C7.12647 5.40934 7.70687 5.40934 8.06485 5.77197Z",
    fill: "#282D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1049 18.3138C9.63274 18.1718 9.36362 17.669 9.50377 17.1908L12.6759 6.36598C12.8161 5.88771 13.3124 5.61509 13.7846 5.75707C14.2567 5.89904 14.5258 6.40185 14.3857 6.88012L11.2135 17.7049C11.0734 18.1832 10.577 18.4558 10.1049 18.3138Z",
    fill: "#282D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9352 5.77197C16.2931 5.40934 16.8735 5.40934 17.2315 5.77197L22.7315 11.3434C23.0895 11.706 23.0895 12.294 22.7315 12.6566L17.2315 18.228C16.8735 18.5907 16.2931 18.5907 15.9352 18.228C15.5772 17.8654 15.5772 17.2775 15.9352 16.9148L20.787 12L15.9352 7.08517C15.5772 6.72254 15.5772 6.1346 15.9352 5.77197Z",
    fill: "#282D61"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbed);
export default __webpack_public_path__ + "static/media/embed.35a8cd15964d35f2d28e156891917ad9.svg";
export { ForwardRef as ReactComponent };